import React from 'react';
import { Stack } from 'expo-router';

export default function MoreLayout() {
  return (
    <Stack
      screenOptions={{
        headerStyle: {
          backgroundColor: '#ffffff',
          borderBottomColor: '#e5e7eb',
          borderBottomWidth: 1,
        },
        headerTintColor: '#0f172a',
        headerTitleStyle: {
          fontWeight: '600',
          fontSize: 17,
        },
        contentStyle: { backgroundColor: '#f8fafc' },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="platform-admin"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="school-management"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="library"
        options={{
          headerShown: false,
        }}
      />
    </Stack>
  );
}
